import React from "react";
import { Page, Text, View, Document, StyleSheet } from "@react-pdf/renderer";
import { getLanguage } from "../Managers/dataProvider";
import { EnumUserAcces, ShiftPlanEmployee } from "../Managers/dataStructures";
import { Table, TH, TD, TR } from "../../../AuxComponents/";

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
  },
  header: {
    backgroundColor: "#FFFFFF",
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  title: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
  },
  table: {
    marginTop: "25px",
  },
  tableHeader: {
    fontWeight: "500",
    fontSize: "14px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
  tableCell: {
    fontWeight: "500",
    fontSize: "12px",
    color: "#111827",
    marginTop: "5px",
    lineHeight: "1.25",
    marginLeft: "5px",
  },
});

interface PDFShiftPlanProps {
  current_date: string;
  branch: string;
  shift: string;
  tl_id: string | undefined;
  array_employees: ShiftPlanEmployee[];
}

export default function PDFShiftPlan(props: PDFShiftPlanProps) {
  const isEnglish = getLanguage();

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <View>
            <View>
              <Text style={styles.title}>
                {isEnglish ? "Schedule" : "Schedule"}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Date : " : "Date : ") + props.current_date}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Branch : " : "Branch : ") + props.branch}
              </Text>
              <Text style={styles.title}>
                {(isEnglish ? "Shift : " : "Shift : ") + props.shift}
              </Text>
            </View>
            <View></View>
            <View style={styles.table}>
              <Table>
                <TH>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Name" : "Name"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Start Time" : "Arbeitsbeginn"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "End Time" : "Arbeitsende"}
                    </Text>
                  </TD>
                  <TD>
                    <Text style={styles.tableHeader}>
                      {isEnglish ? "Role" : "Aufgabe"}
                    </Text>
                  </TD>
                </TH>
                {props.array_employees.map((x) =>
                  CellReportDetail(x, props.tl_id)
                )}
              </Table>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
}

function CellReportDetail(item: ShiftPlanEmployee, tl_id: string | undefined) {
  const isEnglish = getLanguage();
  const isUserTempTL: boolean = item.user.tempRole === undefined ? false : true;

  let isTl: boolean = false;
  if (tl_id !== undefined) {
    isTl = item.user.user_id === tl_id;
  }
  //   const tl: string =
  //     item.user.role.type === EnumUserAcces.TEAM_LEAD ||
  //     item.user.role.type === EnumUserAcces.TEMP_TEAM_LEAD ||
  //     item.user.tempRole?.type === EnumUserAcces.TEMP_TEAM_LEAD ||
  //     isTl
  //       ? "text-green-700 ring-green-600/20 bg-green-50"
  //       : "";

  return (
    <TR key={item.user.user_id}>
      <TD>
        <Text style={styles.tableCell}>
          {item.user.first_name + " " + item.user.last_name}
          {item.user.employee_id}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {item.employee_start_at !== undefined
            ? item.employee_start_at
            : "--:--"}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {item.employee_end_at !== undefined ? item.employee_end_at : "--:--"}
        </Text>
      </TD>
      <TD>
        <Text style={styles.tableCell}>
          {isUserTempTL
            ? item.user.tempRole?.display_name
            : item.user.role.type === EnumUserAcces.TEAM_LEAD
            ? item.user.role.display_name
            : isTl
            ? isEnglish
              ? "Team Lead"
              : "Teamleiter"
            : item.user.role.display_name}
        </Text>
      </TD>
    </TR>
  );
}
